import React, { useContext } from "react";
import { GROEP, groepVan, relLabel, cpVoortgang, isGemeld, datumKort, eenRegel, isIntern, internLabel } from "./afsprakenUtils";
import { OpvolgerLabel } from "./Opvolger";
import { ReactieTeller } from "./Reacties";
import { SnippetContext, fmtReactieTijd } from "./reactieUtils";

export const StatusPill = ({ status }) => (
  <span className={`inline-flex shrink-0 text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full border ${status === "nagekomen" ? "bg-emerald-100 text-emerald-800 border-emerald-200" : "bg-rose-100 text-rose-800 border-rose-200"}`}>
    {status === "nagekomen" ? "Nagekomen" : "Niet nagekomen"}
  </span>
);

export const KlaarLabel = ({ testid }) => (
  <span data-testid={testid} className="inline-flex whitespace-nowrap text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full bg-emerald-600 text-white">Klaar om af te ronden</span>
);

export const GemeldPill = () => (
  <span className="inline-flex text-[10px] font-bold uppercase tracking-wider px-1.5 py-0.5 rounded-full bg-emerald-600 text-white">gemeld</span>
);

export const AfspraakRow = ({ a, selected, onSelect }) => {
  const afgerond = a.status !== "open";
  const g = GROEP[groepVan(a)];
  const { done, total } = cpVoortgang(a);
  const snippet = useContext(SnippetContext)[a.id];
  return (
    <button type="button" data-testid={`afspraak-${a.id}`} onClick={() => onSelect(a)}
      className={`w-full text-left flex items-start gap-3 pl-3 pr-4 py-2.5 border-l-[3px] transition-colors duration-150 ${selected ? "border-l-blue-600 bg-blue-50" : "border-l-transparent hover:bg-zinc-50"}`}>
      {!afgerond && !a.verwijderd && <span className={`mt-1.5 h-2.5 w-2.5 rounded-full shrink-0 ${g.dot}`} data-testid={`afspraak-dot-${a.id}`} data-groep={g.key} />}
      <div className="flex-1 min-w-0 flex flex-col md:flex-row md:items-center gap-1 md:gap-3">
        <div className="md:flex-1 min-w-0 flex items-center gap-2">
          {afgerond && <StatusPill status={a.status} />}
          <span className="min-w-0 flex flex-col">
            <span data-testid={`afspraak-wat-${a.id}`} className="text-sm font-medium text-zinc-900 truncate">{eenRegel(a.wat)}</span>
            {a.vervolgOp && <span data-testid={`afspraak-vervolgtag-${a.id}`} className="text-[10px] font-bold uppercase tracking-wider text-blue-700">Vervolg</span>}
            {a.bron === "locatie" && <span data-testid={`afspraak-door-locatie-${a.id}`} className="text-[10px] font-bold uppercase tracking-wider text-amber-700">door de locatie</span>}
            {isIntern(a) && <span data-testid={`afspraak-intern-${a.id}`} className="text-xs text-zinc-500 truncate">{internLabel(a)}</span>}
            {a.verwijderd && <span data-testid={`afspraak-verwijderd-${a.id}`} className="text-xs text-zinc-500 truncate">Verwijderd door <span className="capitalize">{a.verwijderd.door}</span> op {fmtReactieTijd(a.verwijderd.op)}</span>}
            {snippet && <span data-testid={`afspraak-snippet-${a.id}`} className="text-xs text-zinc-500 truncate">Reactie: {snippet}</span>}
          </span>
        </div>
        <div className="flex items-center gap-2.5 flex-wrap md:flex-nowrap shrink-0">
          {isGemeld(a) && <GemeldPill />}
          {a.afdeling && <span data-testid={`afspraak-afdeling-${a.id}`} className="inline-flex whitespace-nowrap text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full bg-blue-50 text-blue-700 border border-blue-200">{a.afdelingNaam || a.afdeling}</span>}
          <ReactieTeller n={(a.reacties || []).length} testid={`afspraak-reacties-${a.id}`} />
          {total > 0 && <span className="font-mono text-xs text-zinc-500">{done}/{total}</span>}
          <span className="md:w-32"><OpvolgerLabel a={a} testid={`afspraak-opvolger-${a.id}`} /></span>
          {a.verwijderd && !afgerond ? (
            <span className="font-mono text-xs text-zinc-500 whitespace-nowrap md:w-32 md:text-right" data-testid={`afspraak-deadline-${a.id}`}>{a.deadline ? datumKort(a.deadline) : "Geen deadline"}</span>
          ) : afgerond ? (
            <span className="font-mono text-xs text-zinc-500 md:w-24 md:text-right" data-testid={`afspraak-afgerondop-${a.id}`}>{datumKort(a.afgerondOp) || "—"}</span>
          ) : (
            a.klaarOmAfTeRonden ? <span data-testid={`afspraak-deadline-${a.id}`} className="md:min-w-[8rem] md:text-right shrink-0"><KlaarLabel testid={`afspraak-klaar-${a.id}`} /></span>
              : a.wachtOpOm && a.status === "open" ? <span data-testid={`afspraak-deadline-${a.id}`} className="font-mono text-xs md:text-right md:min-w-[8rem] shrink-0 text-blue-700 font-semibold">{a.wachtOpOmLabel}</span>
              : <span data-testid={`afspraak-deadline-${a.id}`} className={`font-mono text-xs whitespace-nowrap md:w-32 md:text-right ${a.overdue ? "text-rose-600 font-bold" : "text-zinc-500"}`}>{relLabel(a)}</span>
          )}
        </div>
      </div>
    </button>
  );
};
